export function setupTikTokLocalCapture() {}

export function initializeTikTok() {}
